import { render, staticRenderFns } from "./imageDialog.vue?vue&type=template&id=6060604e&"
import script from "./imageDialog.vue?vue&type=script&lang=js&"
export * from "./imageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports